"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ItemWithAttributesFragment_1 = __importDefault(require("./ItemWithAttributesFragment"));
const ItemWithBrandFragment_1 = __importDefault(require("./ItemWithBrandFragment"));
const ItemWithCategoryFragment_1 = __importDefault(require("./ItemWithCategoryFragment"));
const ItemWithOffersFragment_1 = __importDefault(require("./ItemWithOffersFragment"));
const ItemWithRatingFragment_1 = __importDefault(require("./ItemWithRatingFragment"));
const ItemWithSubcategoryFragment_1 = __importDefault(require("./ItemWithSubcategoryFragment"));
const ItemRecommendationFragment = (0, graphql_tag_1.default) `
  fragment item on Item {
    adsSellerId
    ads {
      id
      sponsored
    }
    attributes {
      ...attributes
    }
    available
    brand {
      ...brand
    }
    category {
      ...category
    }
    subcategory {
      ...subcategory
    }
    shippingTag(shippingTagRequest: { location: { zipCode: $zipcode } }) {
      cost
      time
      complement
    }
    id
    image
    offerId
    path
    title
    offers(options: $offerOptions) {
      ...offers
    }
    rating {
      ...rating
    }
    tags
  }
  ${ItemWithAttributesFragment_1.default}
  ${ItemWithBrandFragment_1.default}
  ${ItemWithCategoryFragment_1.default}
  ${ItemWithSubcategoryFragment_1.default}
  ${ItemWithOffersFragment_1.default}
  ${ItemWithRatingFragment_1.default}
`;
exports.default = ItemRecommendationFragment;
